<template>
  <section>
    <Banner value="Trabalhe Conosco" />
    <hr style="border: 5px solid #ddd" />

    <section style="background: #ddd">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p class="lead">
              A Escola Engenho cresce a cada ano em qualidade e quantidade. Por
              isso, está sempre em busca dos melhores profissonais comprometidos
              com a educação. Que ser parte desta equipe? Envie seu currículo
              para o email abaixo.
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section class="section">
      <v-container grid-list-xl>
        <v-layout align-start justify-space-around row fill-height wrap my-4>
          <v-flex sm12 style="text-align: center">
            <h1 style="text-align: center; font-size: 25px; line-height: 1.1em">
              <span style="font-size: 45px">Envie seu</span>
              <br />currículo para:
            </h1>
            <br />
            <p class="lead">{{ email }}</p>
            <v-btn :href="'mailto:' + email" round color="default">
              <v-icon style="margin-right: 5px">email</v-icon>Enviar email
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import YouTube from "../../components/YouTube";

export default {
  data: () => ({
    email: "curriculos@escolaengenho.com.br",
  }),
  components: {
    Banner,
    YouTube,
  },
};
</script>

<style lang="scss" scoped>
h2,
h4 {
  text-align: center !important;
}
i.fa-2x {
  margin-right: 10px;
}
</style>
